import React, { useEffect, useState } from "react";
import style from "./MembershipCardDesktop.module.scss";
import MembershipTable from "Components/MembershipPage/MembershipTable";
import MembershipHeader from "Components/MembershipPage/Header";
import InviteMember from "../InviteMember";
import Pagination from "Components/base/Pagination";

export interface IMembershipCardDesktop {
    dataTable: {
        column: Array<{ title: string; key: string; className?: string }>;
        rows: Array<any>;
        actions: Array<{ name: string; action: any }>;
    };
    handleSearch?: any;
    refetchInvitedMembership?: any;
    currentMembership?: any;
    modeScreen?: "family" | "invite";
}
const MembershipCardDesktop = ({
    dataTable,
    handleSearch,
    refetchInvitedMembership,
    currentMembership,
    modeScreen,
}: IMembershipCardDesktop) => {
    console.log("mnbvcxz", dataTable);
    const [openInviteMember, setOpenInviteMember] = useState(false);
    const handleOpenInviteMember = () => {
        setOpenInviteMember(true);
    };
    return (
        <div className={style["MembershipCardDesktop"]}>
            <div className={style["header"]}>
                <MembershipHeader
                    handleClickInviteMemberButton={handleOpenInviteMember}
                    handleSearch={handleSearch}
                    currentMembership={currentMembership}
                    modeScreen={modeScreen}
                />
            </div>
            <MembershipTable dataTable={dataTable} />
            <InviteMember
                open={openInviteMember}
                onClose={() => {
                    setOpenInviteMember(false);
                }}
                refetchInvitedMembership={refetchInvitedMembership}
            />
        </div>
    );
};

export default MembershipCardDesktop;
